import React from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import styles from './index.module.less'
import Tabs from './Tabs'
import ID from './tabsPage/ID'
import Phone from './tabsPage/Phone'
import WorkWechatQuick from './tabsPage/WorkWechatQuick'
import ResetPassword from './resetPassword'
import NationalEmblem from 'assets/national-emblem.png'
import { ErrorBoundary } from 'components'

export default function Index() {
  const location = useLocation() // 获取当前路由
  const searchParams = new URLSearchParams(location.search)
  const hideWxQuick = searchParams.get('hideWxQuick')

  // 登录模块
  const Login = () => (
    <>
      <div className={styles.title} />
      <Tabs />
      <Route path="/phone">
        <div style={{ marginTop: 33 }}>
          <Phone />
        </div>
      </Route>
      <Route path="/id">
        <div style={{ marginTop: 33 }}>
          <ID />
        </div>
      </Route>
    </>
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <div className={styles.img}></div>
        <div className={styles.tips}></div>
      </div>
      <div className={styles.container}>
        {/* app的两步认证，在重置密码时，是不能显示左边的二维码登录的 */}
        {!(location.pathname === '/reset-password' && hideWxQuick) && (
          <ErrorBoundary hidden={true}>
            <div className={styles.left_wechat}>
              <WorkWechatQuick />
            </div>
          </ErrorBoundary>
        )}
        <div className={styles.login}>
          <Switch>
            <Route path={['/id', '/phone']}>
              <Login />
            </Route>
            <Route path="/reset-password">
              <ResetPassword />
            </Route>
            <Redirect to="/id"></Redirect>
          </Switch>
        </div>
      </div>
      <div className={styles.footer}>
        <a
          rel="noreferrer"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index">
          渝ICP备17015694号-1
        </a>
        <img src={NationalEmblem} alt="" />
        <a
          rel="noreferrer"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010302003022">
          渝公网安备50010302003022号
        </a>
      </div>
    </div>
  )
}
